<template>
  <ul>
    <li
      v-for="(image, k) in getImages"
      :key="k"
    >
      <img :src="image">
    </li>
  </ul>
</template>

<script>
import imageFormat from '@/utils/images';

export default {
  name: 'AllCatalogImages',
  props: {
    images: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    getImages () {
      return this.images.map(image => imageFormat.getCdnImage(image.originalImageUrl, 'icon'));
    },
  },
};
</script>
